import axios from "axios";
const BASE_URL = "https://api.openai.com/v1"; // Replace with your API base URL
const API_KEY = import.meta.env.VITE_CHATGPT_API_KEY;

const ChatApi = {
  getChatResponse: async (messages, systemMessageContent) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/chat/completions`,
        {
          model: "gpt-4",
          messages: [
            { role: "system", content: systemMessageContent },
            { role: "user", content: messages },
          ],
          max_tokens: 300,
          temperature: 0.7,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${API_KEY}`,
          },
        }
      );

      return response.data.choices[0].message.content.trim();
    } catch (error) {
      console.error("Error fetching chat response:", error);
      throw error; // Handle or propagate the error as needed
    }
  },
};

export default ChatApi;
